// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4546":"css/admin-app.6840","9968":"css/app.6840"}[chunkId] + ".css";
};